export default __webpack_public_path__ + "static/media/case.f51cc79e.svg";